import usePromoCountdown from "../../../context/usePromoCountdown"
import useStrings from "../../../localization/useStrings"
import styles from "./BlackFriday2025Header.module.scss"
import SaleTag from "./SaleTag"

const BlackFriday2025Header = () => {
  const { minutes, hours, seconds } = usePromoCountdown()
  const strings = useStrings()

  return (
    <div className={styles.header}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>
          <span className={styles.titleBlack}>BLACK</span>
          <span className={styles.titleFriday}>FRIDAY</span>
          <div className={styles.saleTag}>
            <SaleTag />
          </div>
        </div>
      </div>

      <div className={styles.countdown}>
        <div className={styles.countdownTime}>
          {hours.toString().padStart(2, "0")}:
          {minutes.toString().padStart(2, "0")}:
          {seconds.toString().padStart(2, "0")}
        </div>
        <div className={styles.countdownLabel}>
          {strings.premiumToUltimateBlackFriday.timeRemaining}
        </div>
      </div>
    </div>
  )
}

export default BlackFriday2025Header
